// @flow
import searchResultBuilder from './searchResult'
import ondemandSearchTripBuilder from './ondemandSearchTrip'

// Types
import type { OndemandSearchResponse } from '../../../api_types'
import type { SearchResult } from '../../../models/search'

export default function ondemandSearchResultBuilder(
  response: OndemandSearchResponse
): SearchResult {
  const safeRides = response.ride_types
    ? response.ride_types.map((x) => x.rides)
    : []

  const rides = safeRides.reduce(
    (acc, ridesOfType) => [...acc, ...ridesOfType],
    []
  )
  const tripsList = rides.map((result) =>
    ondemandSearchTripBuilder(result, response)
  )

  return {
    ...searchResultBuilder(tripsList),
    alerts: [],
    searchId: response.id,
    createdAt: response.created_at,
    expiresAt: response.expires_at,
    expiresIn: response.expires_in,
  }
}
